import defaultTheme from './default';

const withContext = (current, { main, contrastText }) => ({
  ...defaultTheme,
  palette: {
    ...defaultTheme.palette,
    primary: { ...defaultTheme.palette.primary, main, contrastText },
    context: { ...defaultTheme.palette.context, current, main, contrastText },
  },
});

const sellersTheme = withContext('sellers', defaultTheme.palette.context.sellers);
const institutionsTheme = withContext('institutions', defaultTheme.palette.context.institutions);
const neutralTheme = withContext(null, defaultTheme.palette.primary);

const CONTEXT_THEMES = {
  sellers: sellersTheme,
  institutions: institutionsTheme,
};

function getContextTheme(contextKey) {
  return CONTEXT_THEMES[contextKey] || neutralTheme;
}

export { defaultTheme, getContextTheme, institutionsTheme, sellersTheme };
